<non-admin-lock-panel></non-admin-lock-panel>

<div *ngIf="isAdmin" class="card mt-1">
    <div class="card-header text-center d-flex">
        <h3 class="flex-fill">Relances documentaires</h3>
        <button type="button" class="btn btn-sm btn-primary" (click)="btnRechargerListeClick()">Recharger la liste</button>
    </div>
    <div class="card-body small">
        <div class="row">
            <pre *ngIf="sharedDataSvc.debug">
                State : {{state | json}}
            </pre>
            <div class="col-12">
                <kendo-grid class="group-gradient-blue"
                    id="gridrelancesmano"
                    [data]="lstDatas" 
                    [pageSize]="state.take" 
                    [skip]="state.skip" 
                    [sort]="state.sort"
                    [sortable]="true" 
                    [pageable]="pagerSettings" 
                    [height]="700" 
                    [sortable]="true"
                    [filterable]="'menu'"
                    [filter]="state.filter" 
                    (pageChange)="pageChange($event)"
                    (dataStateChange)="dataStateChange($event)"
                    >
                    <kendo-grid-column field="SupplierName" title="Fournisseur" [sortable]="false">
                        <ng-template kendoGridHeaderTemplate let-column>
                            <button type="button" class="btn btn-sm btn-warning mr-3" (click)="relancerTout()" [disabled]="nothingTodo">Relancer
                                tout</button>
                            <label class="control-label">Fournisseur</label>

                        </ng-template>
                        <ng-template kendoGridGroupHeaderTemplate let-value="value">
                            <div class="d-flex justify-content-between align-items-center">
                                <span [innerHTML]="trafficLightHtml(value)"></span>
                                <button type="button" class="btn btn-xs btn-success mx-2"
                                    (click)="relancer(value)" [disabled]="dejaTraite(value)">Relancer</button>
                                    <a class="control-label" [routerLink]="getSupplierLink(value)" target="_blank">
                                        {{ value }}
                                      </a> 
                                <ul class="flex-fill small">
                                    <li *ngFor="let line of getResultsMessages(value)">
                                        {{line}}
                                    </li>
                                </ul>
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="RefDocLib" title="Document" [width]="300"></kendo-grid-column>
                    <kendo-grid-column field="DateExpi" title="Expire le" [width]="150" [format]="{date:'dd/MM/yyyy' }">
                    </kendo-grid-column>
                    <kendo-grid-column field="DateDerniereRelance" title="Dernière relance" [width]="150"
                        [format]="{ date: 'dd/MM/yyyy' }"></kendo-grid-column>
                    <kendo-grid-column field="DocStatutCod" title="Statut Actuel" [width]="200"></kendo-grid-column>
                    <kendo-grid-column field="StatutCodNext" title="Statut après relance" [width]="200">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
            <!-- <div *ngIf="results.length>0" class="col-12 mt-5 d-flex flex-column">
                <label class="control-label">Résultats du traitement</label>
                <ul class="list-group">
                    <li *ngFor="let res of results"
                        class="list-group-item d-flex justify-content-between align-items-center">
                        <strong>{{res.SupplierName}}</strong>
                        <ul class="flex-fill">
                            <li *ngFor="let line of res.datas.Message.split('|')">
                                {{line}}
                            </li>
                        </ul>
                    </li>
                </ul>
            </div> -->
        </div>

    </div>
</div>